/***
 *
 *   LANDING TEAMS
 *   Split section: positioning copy beside three supporting points.
 *
 **********/

import { useTranslate } from 'app/translations';
import Shared from './landing.tailwind.js';
import Style from './teams.tailwind.js';

/* Bilingual is last on purpose. It used to be the middle point AND appear in
   the hero lede, this section's lede and the footer tagline — four mentions of
   something that is a nice-to-have, not the pitch. This is the only one left. */
const POINTS = ['multiProject', 'roles', 'bilingual'];

export function LandingTeams(props) {
    const { _t } = useTranslate();

    return (
        <section className={Shared.section}>
            <div className={`${Shared.container} ${Shared.split} items-start`}>
                <div>
                    <div className={Shared.eyebrow}>{_t('landing.teams.eyebrow')}</div>
                    <h2 className={`${Shared.title} mb-3.5`}>{_t('landing.teams.title')}</h2>
                    <p className={Style.lede}>{_t('landing.teams.lede')}</p>
                </div>

                <div className={Style.list}>
                    {POINTS.map((point) => (
                        <div key={point} className={Style.item}>
                            <h3 className={Style.title}>{_t(`landing.teams.${point}.title`)}</h3>
                            <p className={Style.desc}>{_t(`landing.teams.${point}.desc`)}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
